var hrDOM = ['hr'];
export var rule = {
    group: 'block',
    parseDOM: [{ tag: 'hr' }],
    toDOM: function () {
        return hrDOM;
    },
};
//# sourceMappingURL=rule.js.map